module.exports = __webpack_public_path__ + "media/greenhouse-fullhd01.e84ba71a.mp4";